import React, {
    FunctionComponent,
    useEffect,
    useState,
    useRef,
  } from "react";
  import styles from "../BulkEditModal/BulkEditModal.module.css";
  import Modal from "react-modal";
  import { IoIosClose } from "react-icons/io";
  import { connect, useDispatch } from "react-redux";
  import Dropdown from "../../DropDown/Dropdown";
  import {
    addNoteFirebase,
    addNoteMongo,
    changeLeadStage,
    fetchConstants,
  } from "../../../Services/contacts";
  
  import Loading from "../../Loading/Loading";
  import { showSnackbarAction } from "../../../Redux/actions";
  import { useHistory } from "react-router-dom";
  import {themeColors} from "../../theme";
  import Label from "../../Label";
  import { motion,AnimatePresence } from "framer-motion";
  import Backdrop from "../../Backdrop/Backdrop";
import { uploadProjectTemplate } from "../../../Services/resources";
  
type props = {
  open: boolean;
  close: () => void;
  // title: string;
  projectData: any;
  type: string;
  project_template?:any;
  user?: any;
  theme:any;
  authToken:any;
};
  
  const dropIn = {
    hidden: {
      y: "-100vh",
      opacity: 1,
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 1,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
  };
  
  const ProjectsNotesModal: FunctionComponent<props> = ({
  open,
  close,
  projectData,
  type,
  project_template,
  user,
  theme,
  authToken
  }) => {
    const [load, setLoad] = useState(false);
    const [template, setTemplate] = useState("");
  
    const noteRef: any = useRef();
    const dispatcher = useDispatch();
    const history = useHistory();
    const [file, setFile] = useState<any>();
    const onSubmit = async () => {
      if (noteRef.current.value === "") {
        dispatcher(
          showSnackbarAction("Please Add Project Template!!", "error")
        );
      } else {
    setLoad(true);
    await uploadProjectTemplate(
      projectData,
      type,
      dispatcher,
      template,
      user,
      authToken
      );
      close();
      }
    };  
    const customStyles = {
      content: {
        backgroundColor:theme ? themeColors.dropdownBackgroundColor:themeColors.dropdownBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
      },
    };
    const containerStyles = { backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
    useEffect(()=>{setTemplate(project_template)},[])
    return (
      <>
        {load === true && <Loading />}
        {open && <Backdrop>
          <motion.div
                     key="modal"
                     className="card p-4 shadow rounded"
                     style={{position: "absolute",minWidth: "400px",
                     ...containerStyles}}
                     variants={dropIn}
                     initial="hidden"
                     animate="visible"
                     exit="exit"
                   >
        <div className={styles.firstDiv}>
          <h5 
          >
            Add Details
          </h5>
          <div className={styles.cross} onClick={close}>
            <IoIosClose size={35} color={"#808080"} />
          </div>
        </div>
        <div className={styles.line}></div>
  
        <div className={styles.box2}>
          <div
            className={styles.divide}
            style={{ width: "100%" }}
          >
            {/* <Label label="Add Template" required={false} /> */}
            <div style={{ marginTop: "7px" }}>
              <textarea
              className="form-control"
                style={{
                  width: "100%",
                  resize: "none",
                }}
                disabled={false}
                readOnly={false}
                rows={4}
                cols={10}
                placeholder={"Enter Project Template"}
                ref={noteRef}
                onChange={(e) => setTemplate(e.target.value)}
                value={template?template:""}
              ></textarea>
            </div>
          </div>
        </div>
  
        <button
          className={styles.apply}
          style={{ marginTop: "2rem" }}
          onClick={onSubmit}
        >
          Save
        </button>
                   </motion.div>
          </Backdrop>}
      </>
    );
  };
  
  const mapStateToProps = (state: any) => {
    return {
      theme: state.theme.isLightMode,
      authToken:state.user.authToken
    };
  };
  
  export default connect(mapStateToProps)(ProjectsNotesModal);